module.exports = __webpack_public_path__ + "img/mypokedek.aa68a134.jpg";